import { useCallback } from "react";
import { validateCnpj as newValidateCnpj } from "../../utils";

export const useCnpjService = () => {
  const validateCnpj = useCallback((cnpj: string) => {
    if (!cnpj) return false;
    
    return newValidateCnpj(cnpj);
  }, []);

  return {
    validateCnpj,
  };
};